import { Container, Typography } from '@mui/material';
import React from 'react';

import LazyImage from '../../Layouts/LazyImage';

import style from './style';

const Hero = () => {
  const classes = style();

  return (
    <Container component="section" className={`${classes.section} `}>
      <div className={classes.container}>
        <div className={classes.textBox}>
          <Typography variant="h2" component="h1" align="right">
            It's good to hear from you
          </Typography>
          <Typography variant="body1" align="right">
            Whether you have a question or a suggestion, just write to us.
          </Typography>
        </div>
        <div className={classes.imgBox}>
          <LazyImage
            sizes={sizes}
            src="/images/contactUs/hero/contact_us.png"
            alt=""
          />
        </div>
      </div>
    </Container>
  );
};

const sizes = {
  xs: [160, 231],
  sm: [326, 474],
  md: [230, 334],
  xxl: [290, 420],
};

export default Hero;
